module.exports = __webpack_public_path__ + "img/01n.c607ee0a.png";